import { useQuery } from '@tanstack/react-query';

import { api } from '~/shared/services/api';

export type PreferredLanguageResponse = {
  language: string;
};

async function getPreferredLanguage(): Promise<PreferredLanguageResponse> {
  const { data } = await api.get<PreferredLanguageResponse>(
    '/api/user-access-management/employees/preferred-language'
  );
  return data;
}

export function usePreferredLanguage() {
  return useQuery({
    queryKey: ['preferred-language'],
    queryFn: getPreferredLanguage,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false
  });
}
